import axios from "axios"
import {setQuery} from "../utils/utils";

interface DataApi{
    vehicleId: string,
    driverId: string
    end_date: string,
    start_date: string
}

async function getExceedingSpeedLimitByVehicleApi(data: DataApi){
    const { vehicleId, start_date, end_date } = data;
    return axios({
        method:"GET",
        url: `/api/v1/exceeding-speed-limits/${vehicleId}${setQuery({start_date}, {end_date})}`
    })
}

async function getExceedingSpeedLimitByDriverApi(data: DataApi){
    const { driverId, start_date, end_date } = data;
    return axios({
        method:"GET",
        url: `/api/v1/exceeding-driver-limits/${driverId}${setQuery({start_date}, {end_date})}`
    })
}

async function getExceedingRpmLimitByVehicleApi(data: DataApi){
    const { vehicleId, start_date, end_date } = data;
    return axios({
        method:"GET",
        url: `/api/v1/exceeding-rpm-limits/${vehicleId}${setQuery({start_date}, {end_date})}`
    })
}

async function getExceedingRpmLimitByDriverApi(data: DataApi){
    const { driverId, start_date, end_date } = data;
    return axios({
        method:"GET",
        url: `/api/v1/exceeding-rpm-driver-limits/${driverId}${setQuery({start_date}, {end_date})}`
    })
}

async function getDriverStatsApi(data: DataApi){
    const { driverId, start_date, end_date } = data;
    return axios({
        method: "GET",
        url: `/api/v1/driver-stats/driver/${driverId}${setQuery({start_date}, {end_date})}`

    })
}

async function getIgnitionOnSpeedByVehicleIdApi(data: DataApi){
    const { vehicleId, start_date, end_date } = data;
    return axios({
        method: "GET",
        url: `/api/v1/ignition-speed-report/${vehicleId}${setQuery({start_date}, {end_date})}`
    })
}

async function getIgnitionOnRpmByVehicleIdApi(data: DataApi){
    const { vehicleId, start_date, end_date } = data;
    return axios({
        method: "GET",
        url: `/api/v1/ignition-rpm-report/${vehicleId}${setQuery({start_date}, {end_date})}`
    })
}


export {
    getExceedingRpmLimitByDriverApi,
    getExceedingRpmLimitByVehicleApi,
    getExceedingSpeedLimitByDriverApi,
    getExceedingSpeedLimitByVehicleApi,
    getDriverStatsApi,
    getIgnitionOnSpeedByVehicleIdApi,
    getIgnitionOnRpmByVehicleIdApi
}